import React from 'react';
import { Building2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Label } from '../../../components/ui/label';
import { Badge } from '../../../components/ui/badge';
import { getPricingTierBadgeClass } from '../../../lib/statusHelpers';

export const AccountTab = ({ account }) => (
  <Card data-testid="account-card">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <Building2 className="h-5 w-5 text-amber-500" />
        Company Information
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label className="text-gray-500">Company Name</Label>
          <p className="font-medium text-lg mt-1">{account.company_name}</p>
        </div>
        <div>
          <Label className="text-gray-500">Account Number</Label>
          <p className="font-medium text-lg mt-1">{account.account_number}</p>
        </div>
        <div>
          <Label className="text-gray-500">Account Status</Label>
          <div className="mt-1">
            <Badge className={`${
              account.status === 'active'
                ? 'bg-green-100 text-green-800'
                : 'bg-gray-100 text-gray-800'
            }`}>
              {account.status}
            </Badge>
          </div>
        </div>
        <div>
          <Label className="text-gray-500">Pricing Tier</Label>
          <div className="mt-1 flex items-center gap-2">
            <Badge
              className={getPricingTierBadgeClass(account.pricing_tier)}
              data-testid="pricing-tier-badge"
            >
              {account.pricing_tier?.name || 'Standard'}
            </Badge>
            {account.pricing_tier?.discount_percent > 0 && (
              <span className="text-sm text-gray-600">
                ({account.pricing_tier.discount_percent}% off)
              </span>
            )}
            {account.pricing_tier?.has_guaranteed_returns && (
              <span className="text-xs text-purple-600 font-medium">
                Returns Eligible
              </span>
            )}
          </div>
        </div>
        <div>
          <Label className="text-gray-500">Payment Terms</Label>
          <p className="font-medium mt-1">
            {account.preferences?.payment_terms || 'Net 30'}
          </p>
        </div>
      </div>
      <div className="pt-4 border-t">
        <p className="text-sm text-gray-500">
          Need to update your company information? Contact us at{' '}
          <a href="mailto:wholesale@maddonuts.com" className="text-amber-600 hover:text-amber-700">
            wholesale@maddonuts.com
          </a>
        </p>
      </div>
    </CardContent>
  </Card>
);
